import { InstallmentPlansResponse } from '@common/entities';
import { get } from 'config/api/config';

export const getInstallmentPlans = async (
  propertyId: number,
  leaseTermId: number,
  companyApplicationId: number,
  leaseStartWindowId?: number,
  leaseIntervalId?: number,
): Promise<InstallmentPlansResponse> => {
  const params = new URLSearchParams({
    propertyId: propertyId.toString(),
    leaseTermId: leaseTermId.toString(),
    companyApplicationId: companyApplicationId.toString(),
  });

  if (leaseStartWindowId) params.append('leaseStartWindowId', leaseStartWindowId.toString());
  if (leaseIntervalId) params.append('leaseIntervalId', leaseIntervalId.toString());

  const response = await get<InstallmentPlansResponse>(`/viewer/installment-plans?${params}`);
  return response.data;
};
